import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Divider, Form } from 'antd';

import CompanyGeneralInfoForm from '@/components/Companies/CompanyGeneralInfoForm';
import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import { store } from '@/Root';
import { authOperations } from '@/state/ducks/auth';
import { PageProps } from '@/types/PageProps';
import { useCompanyCreate } from '@/core/domain/enterprise/Companies/Companies.hooks';
import {
  CompanyCreateRequest,
  CompanyFormValues,
} from '@/core/domain/enterprise/Companies/Companies.types';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { removeMask } from '@/utils/mask';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

const CreateCompanyPage = ({ route }: PageProps) => {
  const history = useHistory();
  const [form] = Form.useForm<CompanyFormValues>();

  const createMutation = useCompanyCreate();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();
      const obj: CompanyCreateRequest = {
        ...values,
        active: true,
        contactList: !values.contactList
          ? undefined
          : values.contactList
              .filter(
                (item) =>
                  item.value !== undefined && item.contactType !== undefined,
              )
              ?.map((item) => ({
                ...item,
                active: true,
              })),
        logo: values.logo
          ? values.logo.length > 0
            ? values.logo[0].response.filePath
            : undefined
          : null,
        pecaAiContactPhone: removeMask(values.pecaAiContactPhone),
      };

      const response = await createMutation.mutateAsync(obj);
      await store.dispatch(authOperations.handleRefreshToken());

      history.push(`/app/registry/companies/${response.id}`);
    } catch {}
  };

  return (
    <TabContentWrapper
      permissions={route.permissions}
      title={route.name}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSaveClick}
          loading={createMutation.isLoading}
          disabled={!hasPermissions([Authorities.REGISTER_COMPANY_ADD])}
        >
          <FormattedMessage id="commons.form.button.save" />
        </SaveButton>
      }
    >
      <CompanyGeneralInfoForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/registry/companies" />
      </SpaceForButton>
    </TabContentWrapper>
  );
};

export default CreateCompanyPage;
